export default __webpack_public_path__ + "static/media/necklace_2.148f9fd9.webp";